export const DOWNLOAD_DOCUMENT_FAILURE = 'DOWNLOAD_DOCUMENT_FAILURE';

export const downloadDocumentFailure = error => ({
    type: DOWNLOAD_DOCUMENT_FAILURE,
    payload: error,
    error: true,
});
